export let locale = {

    format: 'DD-MM-YYYY',
    hiddenFormat: 'YYYY-MM-DD',

    "separator": " - ",
    "applyLabel": "Toepassen",
    "cancelLabel": "Annuleren",
    "fromLabel": "Van",
    "toLabel": "Naar",
    "customRangeLabel": "Afwijkend",
    "weekLabel": "W",
    "daysOfWeek": [
        "Zo",
        "Ma",
        "Di",
        "Wo",
        "Do",
        "Vr",
        "Za"
    ],
    "monthNames": [
        "januari",
        "februari",
        "maart",
        "april",
        "mei",
        "juni",
        "juli",
        "augustus",
        "september",
        "oktober",
        "november",
        "december"
    ],
    "firstDay": 1,
};